import React, { useEffect } from 'react';

import {
  DEFAULT_COMPANY_THEME_KEY,
  companyThemes,
  getCompanyTheme,
} from './companyThemes';

export default function CompanyThemeProvider({
  themeKey = DEFAULT_COMPANY_THEME_KEY,
  children,
}) {
  useEffect(() => {
    if (typeof document === 'undefined') return undefined;

    const root = document.documentElement;
    const resolvedThemeKey = companyThemes[themeKey] ? themeKey : DEFAULT_COMPANY_THEME_KEY;
    const theme = getCompanyTheme(resolvedThemeKey);
    const previousThemeAttr = root.getAttribute('data-company-theme');
    const previousValues = {};

    Object.entries(theme).forEach(([cssVariable, value]) => {
      const existingValue = root.style.getPropertyValue(cssVariable);

      previousValues[cssVariable] = {
        existed: existingValue !== '',
        value: existingValue,
      };

      root.style.setProperty(cssVariable, value);
    });

    root.setAttribute('data-company-theme', resolvedThemeKey);

    return () => {
      Object.keys(theme).forEach((cssVariable) => {
        const previousEntry = previousValues[cssVariable];

        if (previousEntry?.existed) {
          root.style.setProperty(cssVariable, previousEntry.value);
          return;
        }

        root.style.removeProperty(cssVariable);
      });

      if (previousThemeAttr !== null) {
        root.setAttribute('data-company-theme', previousThemeAttr);
        return;
      }

      root.removeAttribute('data-company-theme');
    };
  }, [themeKey]);

  return children;
}
